import React from 'react';
import { getSmoothStepPath, getBezierPath, getStraightPath, EdgeText, } from 'reactflow';
const shapeUtilsMap = {
    Bezier: getBezierPath,
    SmoothStep: getSmoothStepPath,
    Straight: getStraightPath,
};
const isNumeric = (n) => !isNaN(n) && isFinite(n);
const BaseEdge = ({ id, path, labelX, labelY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth = 20, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { id: id, style: style, d: path, fill: "none", className: `react-flow__edge-path` }),
        interactionWidth && (React.createElement("path", { d: path, fill: "none", strokeOpacity: 0, strokeWidth: interactionWidth, className: `react-flow__edge-interaction`, markerStart: markerStart, markerEnd: markerEnd })),
        label && isNumeric(labelX) && isNumeric(labelY) ? (React.createElement(EdgeText, { x: labelX, y: labelY, label: label, labelStyle: labelStyle, labelShowBg: labelShowBg, labelBgStyle: labelBgStyle, labelBgPadding: labelBgPadding, labelBgBorderRadius: labelBgBorderRadius })) : null));
};
export default function ReactBaseEdge({ shapeInfo, instance, config }) {
    const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition } = shapeInfo;
    const [edgePath] = shapeUtilsMap[config.shapeType]({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });
    const { primaryColor, highlight } = instance;
    return (React.createElement(React.Fragment, null,
        React.createElement("marker", { id: "marker-v45-2553820855", overflow: "visible", orient: "auto", markerUnits: "userSpaceOnUse" },
            React.createElement("path", { stroke: primaryColor, fill: primaryColor, style: {
                    strokeDasharray: 'none',
                    animation: 'none',
                }, transform: "rotate(180)", d: "M 0 0 L 6 -3 L 6 3 Z" })),
        React.createElement(BaseEdge, { markerEnd: `url(#marker-v45-2553820855)`, path: edgePath, style: {
                stroke: primaryColor,
            }, className: "animated" }),
        highlight ? (React.createElement(BaseEdge, { path: edgePath, style: {
                stroke: primaryColor,
                opacity: 0.2,
                strokeWidth: 4,
            } })) : null));
}
//# sourceMappingURL=index.js.map